import React from "react"

import Base from "../UserPanel/Base"
import NewUserForm from "../../Components/Users/NewUserForm"

function NewUser() {

    const routes = [
        {
            path: "/home",
            breadcrumbName: "Home"
        },
        {
            path: "/usuarios",
            breadcrumbName: "Usuarios"
        },
        {
            path: "new-user",
            breadcrumbName: "Editar usuario"
        }
    ]

    return(
        <Base
            title="Editar usuario"
            routes={routes}
        >
            <NewUserForm />
        </Base>
    );
}

export default NewUser;